import { render, staticRenderFns } from "./PlayerName.vue?vue&type=template&id=910d5d34&scoped=true&"
import script from "./PlayerName.vue?vue&type=script&lang=ts&"
export * from "./PlayerName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910d5d34",
  null
  
)

export default component.exports